import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import AccountCreateSF from '../../components/connectedAccount/AccountCreateSF'

const AccountCreatePageUI = ({context, messageList, errorList, stripeApiKey}) =>
  <PrivatePageSF context={context} className='pg_acc_create' backLink='/settings/user/teams' centered={!stripeApiKey || errorList}
    messageList={messageList} headerMessageKey='c_create_account' >
    {
      !stripeApiKey && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      stripeApiKey && !errorList &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings/user/teams' messageList={messageList} titleMessageKey='c_create_account' />
        <AccountCreateSF context={context} stripeApiKey={stripeApiKey} messageList={messageList} />
      </div>
    }
  </PrivatePageSF>

export default AccountCreatePageUI
